import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from 'modules/common';
import { getRequestDetailsMapped } from 'pages/requestList/containers/card/Toolbar/Toolbar.helpers';
import { useCallback } from 'react';

export const useInvalidateDuplicates = (requestId: string) => {
    const queryClient = useQueryClient();

    return useCallback(
        (additionalIds?: string[]) => {
            queryClient.invalidateQueries([QueryKeys.CONTACT_INFO, requestId]);

            const detailsData = queryClient.getQueryData<Awaited<ReturnType<typeof getRequestDetailsMapped>>>([
                QueryKeys.CONTACT_INFO,
                requestId,
            ]);

            if (detailsData && detailsData.possibleDuplicates?.length > 0) {
                detailsData.possibleDuplicates.forEach((item) => {
                    queryClient.invalidateQueries([QueryKeys.CONTACT_INFO, item.requestId]);
                });
            }

            if (additionalIds) {
                additionalIds.forEach((id) => {
                    queryClient.invalidateQueries([QueryKeys.CONTACT_INFO, id]);
                });
            }
        },
        [queryClient, requestId]
    );
};
